import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtAgo = (s) => {
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export default function ActivityTicker() {
  const [activity, setActivity] = useState([]);
  useEffect(() => {
    const load = () => axios.get(`${BASE}/drop/activity?limit=12`).then(r => setActivity(r.data)).catch(() => {});
    load();
    const i = setInterval(load, 12000);
    return () => clearInterval(i);
  }, []);

  if (!activity.length) return null;

  // Double the list so the marquee can loop seamlessly
  const loop = [...activity, ...activity];

  return (
    <div className="rc-panel relative overflow-hidden px-3 py-2 mb-4" data-testid="activity-ticker">
      <div className="flex items-center gap-3">
        <span className="rc-label text-[10px] whitespace-nowrap flex items-center gap-1">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--rc-success)] rc-pulse-glow" />
          LIVE
        </span>
        <div className="overflow-hidden flex-1 relative">
          <div className="flex gap-8 animate-marquee whitespace-nowrap">
            {loop.map((a, i) => (
              <span key={i} className="text-xs flex items-center gap-2">
                <span className="font-display text-[var(--rc-gold)]">{a.name}</span>
                <span className="text-[var(--rc-text-dim)]">just grabbed</span>
                <span className="rc-glow-text">{a.item}</span>
                <span className="text-[var(--rc-text-dim)]">·</span>
                <span className="rc-label text-[9px]">{fmtAgo(a.ago_seconds)}</span>
                <span className="text-[var(--rc-gold-dim)]">◆</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
